export default "__VITE_ASSET__CekHlpO6__"